// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-card__ref .slider__controls{opacity:0;pointer-events:none;transition:opacity .2s var(--asphalte-animation-function)}@media (min-width:48.0625em) and (hover:hover) and (pointer:fine){.product-card__ref:hover .slider__controls{opacity:1;pointer-events:all}}@media (min-width:48.0625em){.product-card__ref:focus-visible .slider__controls{opacity:1;pointer-events:all}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
